import React from "react";

import IsRequired from "../../../LeadCompliance/components/Table/IsRequired";
import Report from "./Report";

function Roaches({ params, refetchUnits }) {
  const { compliance } = params.row;
  const isRequired = compliance?.visible_cockroaches;

  return compliance?.status == "pending" ? (
    ""
  ) : (
    <IsRequired
      required={isRequired}
      attachment={compliance?.ll55_visible_cockroaches_report}
    >
      <Report
        id={compliance.ll55_id}
        attachment={compliance?.ll55_visible_cockroaches_report}
        refetchUnits={refetchUnits}
        status={"Report-Needed"}
        type={"cockroaches"}
      />
    </IsRequired>
  );
}

export default Roaches;
